"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _legacyI18nInit = require("../internal/legacyI18nInit");

var _hsIntl = require("../internal/hs-intl");

var _localeMapper = _interopRequireDefault(require("../internal/localeMapper"));

var localStorage = _interopRequireWildcard(require("../internal/localStorage"));

var _default = function _default(options) {
  var intl = (0, _hsIntl.create)();
  var _setLocale = intl.setLocale,
      _register = intl.register,
      rest = (0, _objectWithoutProperties2.default)(intl, ["setLocale", "register"]);
  var localesToLoad = [];
  var I18nProvider = (0, _extends2.default)({
    register: function register(lang) {
      var registerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var mapper = registerOptions.localeMapper || _localeMapper.default;

      var p = _register.call(intl, lang, (0, _extends2.default)({}, registerOptions, {
        localeMapper: function localeMapper() {
          var l = mapper.apply(void 0, arguments);

          if (l && !localesToLoad.includes(l)) {
            localesToLoad.push(l);
          }

          return l;
        }
      }));

      p.then(function () {
        return localStorage.setItem(options && options.__localesCacheKey || 'i18n-cached-standard-locales', JSON.stringify(localesToLoad));
      });
      return p;
    },
    setLocale: function setLocale(_ref) {
      var locale = _ref.locale,
          langEnabled = _ref.langEnabled,
          timezone = _ref.timezone;
      (0, _legacyI18nInit.setManualOverwrites)();
      (0, _legacyI18nInit.setupTimezone)(timezone);
      I18n.locale = I18n.manualLocale || (0, _legacyI18nInit.getValidLocale)(locale);
      I18n.langEnabled = !!I18n.manualLocale || langEnabled;
      var loaderLocales = [I18n.locale];
      var shouldLoadFallback = !(options && options.excludeFallback);

      if (shouldLoadFallback && I18n.locale !== _legacyI18nInit.defaultLanguage) {
        loaderLocales.push(_legacyI18nInit.defaultLanguage);
      }

      I18n.fired.ready = true;
      I18n.Info.resolve({
        locale: I18n.locale,
        langEnabled: I18n.langEnabled,
        timezone: I18n.timezone
      });

      if (I18n.moment) {
        var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.split('-')[0]] || _legacyI18nInit.defaultLanguage;

        I18n.moment.locale(validMomentLocale);
      }

      return _setLocale(loaderLocales);
    }
  }, rest);
  return I18nProvider;
};

exports.default = _default;
module.exports = exports.default;